import { Component, forwardRef, EventEmitter, OnInit, Input, Output } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import { Message, OverlayPanel, SelectItem } from 'primeng/primeng';

import * as ent from '../../entities/index'
import * as serv from '../../services/index'

//constants
import { Constants } from '../../constants/Constants';

//base
import { BaseDropdownComponent } from '../../baseclasses/BaseDropdown.component';

@Component({
    selector: 'my-globalcustomer-dropdown',
    templateUrl: './GlobalCustomerDropdown.component.html',
    providers: [{ provide: BaseDropdownComponent, useExisting: forwardRef(() => GlobalCustomerDropdownComponent) }]
})
export class GlobalCustomerDropdownComponent extends BaseDropdownComponent {


    constructor(private domainDataService: serv.DomainDataService) {
        super();
    }


    ngOnInit(): void {
    }

    public load() {
        this.domainDataService.getGlobalCustomers().subscribe(x => this.onGetGlobalCustomersDone(x));
    }

    onGetGlobalCustomersDone(items: ent.GlobalCustomer[]) {
        this.selectItems.push({ label: "", value: Constants._NONE });
        items.forEach(y => this.selectItems.push({ label: y.FullName, value: y.ID }));
        this.value = this.selectedID;
    }

}